import React from 'react';
import { Alert } from '../ui';

interface RecipeFormAlertProps {
  message: string;
  isError: boolean;
  testId?: string;
}

const RecipeFormAlert: React.FC<RecipeFormAlertProps> = ({
  message,
  isError,
  testId,
}) => {
  if (!message) {
    return null;
  }

  return (
    <Alert
      data-testid={testId}
      marginTop={3}
      variant={isError ? 'danger' : 'success'}
    >
      {message}
    </Alert>
  );
};

export default RecipeFormAlert;
